import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type CustomBadgeProps = {
  position?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left';
  children: React.ReactNode;
};
const CustomBadge = t0 => {
  const $ = _c(6);
  const {
    children,
    position: t1
  } = t0;
  const position = t1 === undefined ? "top-right" : t1;
  const t2 = position === "top-right";
  let t3;
  if ($[0] !== position || $[1] !== t2) {
    t3 = cx(["absolute top-0 right-2 px-2 py-0.5 text-caption-3 text-quinary bg-accent", {
      "top-0 right-2 -translate-y-full rounded-t-sm": t2
    }, {
      "bottom-0 right-2 translate-y-full rounded-b-sm": position === "bottom-right"
    }, {
      "top-0 left-2 -translate-x-full rounded-t-sm": position === "top-left"
    }, {
      "bottom-0 left-2 translate-x-full rounded-b-sm": position === "bottom-left"
    }]);
    $[0] = position;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default CustomBadge;